import { WeightUnits } from '@features/Quiz/constants';

const LBS_MULTIPLIER = 2.204_622_621_85;

const lbsToKg = (value: number) => value / LBS_MULTIPLIER;

const kgToLbs = (value: number) => value * LBS_MULTIPLIER;

const uniformGoalWeight = ({
  weightUnits,
  goalWeightUnits,
  goalWeightValue,
}: {
  weightUnits: WeightUnits;
  goalWeightUnits: WeightUnits;
  goalWeightValue: number;
}) => {
  if (weightUnits === goalWeightUnits) {
    return goalWeightValue;
  }

  const selectUnit = {
    [WeightUnits.LBS]: lbsToKg(goalWeightValue),
    [WeightUnits.KG]: kgToLbs(goalWeightValue),
  };

  return selectUnit[goalWeightUnits];
};

const LBS_COUNTRIES = ['US', 'GB', 'CA', 'AU', 'NZ'];

const shouldUseLbs = (countryCode?: string): boolean => {
  if (!countryCode) return false;
  return LBS_COUNTRIES.includes(countryCode.toUpperCase());
};

const formatWeight = (weight: string, countryCode?: string) => {
  const isLbs = shouldUseLbs(countryCode);
  const numericWeight = Number.parseInt(weight);

  if (isLbs) {
    const lbs = Math.round(numericWeight * 2.20462); // kg to lbs
    return `${lbs} lbs`;
  }

  return `${weight} kg`;
};

export { formatWeight, shouldUseLbs, uniformGoalWeight, lbsToKg, kgToLbs };
